

export function getCurrentTime() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0'); // Lấy giờ
    const minutes = now.getMinutes().toString().padStart(2, '0'); // Lấy phút
    const seconds = now.getSeconds().toString().padStart(2, '0'); // Lấy giây

    return `${hours}:${minutes}:${seconds}`;
}
export function getCurDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    const result = yyyy + '-' + mm + '-' + dd;
    return result
}
export function getDateTimeString(timestamp) {
    return getDateStringVN(timestamp) + " " + getTimeString(timestamp)
}
export function getDateString(timestamp) {
    var today = new Date(timestamp);
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    const ret = yyyy + '-' + mm + '-' + dd;
    return ret
}
export function getDateStringVN(timestamp) {
    var today = new Date(timestamp);
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    // today = yyyy + '-' + mm + '-' + dd;
    let result = dd + '/' + mm + '/' + yyyy;
    return result
}
export function getTimeString(timestamp) {
    var today = new Date(timestamp);
    var hh = String(today.getHours()).padStart(2, '0');
    var mm = String(today.getMinutes()).padStart(2, '0'); //January is 0!
    var ss = String(today.getSeconds()).padStart(2, '0');

    let ret = hh + ':' + mm + ':' + ss;
    return ret
}
export function changeDateFromUsToVn(date) {
    let year = date.substring(0, 4);
    let month = date.substring(5, 7);
    let day = date.substring(8, 10);
    return `${day}/${month}/${year}`;
}
export function secondsToDate(seconds) {
    const date = new Date(0);
    date.setUTCSeconds(seconds);
    return date;
}
export function secondsToDateString(seconds) {
    const date = new Date(0);
    date.setUTCSeconds(seconds);
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    // today = yyyy + '-' + mm + '-' + dd;
    let result = yyyy + '-' + mm + '-' + dd;
    return result
}
export function dateToDateString(date) {

    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    // today = yyyy + '-' + mm + '-' + dd;
    let result = yyyy + '-' + mm + '-' + dd;
    return result
}
export function secondsToTimeString(seconds) {
    const date = new Date(0);
    date.setUTCSeconds(seconds);
    var hh = String(date.getHours()).padStart(2, '0');
    var mm = String(date.getMinutes()).padStart(2, '0'); //January is 0!
    var ss = String(date.getSeconds()).padStart(2, '0');

    let time = hh + ':' + mm + ':' + ss;
    return time
}
export function dateToTimeString(date) {

    var hh = String(date.getHours()).padStart(2, '0');
    var mm = String(date.getMinutes()).padStart(2, '0'); //January is 0!
    var ss = String(date.getSeconds()).padStart(2, '0');

    const time = hh + ':' + mm + ':' + ss;
    return time
}
export function dateToSeconds(date) {
    return Math.floor(date.getTime() / 1000);
}
export function getDayOfWeek(dateString) {
    const daysOfWeek = ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'];

    // Tạo một đối tượng Date từ chuỗi ngày
    const date = new Date(dateString);

    // Lấy thứ trong tuần (0 - Chủ Nhật, 1 - Thứ Hai, ..., 6 - Thứ Bảy)
    const dayOfWeek = date.getDay() + 1;

    return dayOfWeek;
}
export function isValidTime(timeString) {
    // Biểu thức chính quy để kiểm tra định dạng thời gian 24 giờ: HH:mm:ss
    var regex = /^(?:[01]\d|2[0-3]):(?:[0-5]\d):(?:[0-5]\d)$/;
    
    // Kiểm tra xem chuỗi thời gian có khớp với biểu thức chính quy không
    return regex.test(timeString);
}
export function addDays(dateString, days) {
    let date = new Date(dateString); // Chuyển đổi chuỗi thành đối tượng Date
    if (isNaN(date)) {
        throw new Error("Ngày không hợp lệ");
    }
    date.setDate(date.getDate() + days); // Cộng hoặc trừ ngày
    return date.toISOString().split('T')[0]; // Trả về chuỗi ngày theo định dạng YYYY-MM-DD
}
export function getCurrentTimeMillis() {
    return Date.now(); // Trả về số mili giây từ 01/01/1970
}